import { ApiService } from "./ApiService"

export class WhatsAppService {

    static uri = '/whatsapp';

    static getStatus({ sessionId }) {
        return ApiService.get(`${this.uri}/status/${sessionId}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }

    // Kirim pesan dengan menentukan session_id yang dipakai
    static sendManual({ data }) {
        // data: { session_id: 'device_billing', phone: '0812...', message: '...' }
        return ApiService.post(`${this.uri}/send`, data, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
                'Content-Type': 'application/json'
            }
        });
    }
    
    // static getStatus() {
    //     return ApiService.get(`${this.uri}/status`, {
    //         headers: {
    //             Authorization: `Bearer ${localStorage.getItem('token-radiustrend')}`
    //         }
    //     });
    // }

    // static sendManual({ data }) {
    //     return ApiService.post(`${this.uri}/send`, data, {
    //         headers: {
    //             'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
    //             'Content-Type': 'application/json'
    //         }
    //     });
    // }

    /**
     * Logout / Disconnect WhatsApp dari Gateway
     */
    static logout() {
        return ApiService.post(`${this.uri}/logout`, {}, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }
}